export function bindSearchAutocomplete(containerId, outputSearchTerm) {
    let timeout = null;
    const textInput = $(containerId + ' .search-textbox');
    const autoComplete = $(containerId + ' .search-autocomplete');

    let autocompleteSelectedIndex = 0;

    textInput.off('keyup').on('keyup', function (e) {
        const autoCompleteItemCount = autoComplete.find('li').length;

        // If the up or down arrow is pressed then navigate through the list items.
        if (e.keyCode === 40 && autoComplete.hasClass('active') || e.keyCode === 38 && autoComplete.hasClass('active')) {

            if (e.keyCode === 38 && autoComplete.find('li').eq(0).hasClass('active'))
                return false;

            if (e.keyCode === 40 && autocompleteSelectedIndex === autoCompleteItemCount)
                return false;

            autoComplete.find('li').removeClass('active');

            if (e.keyCode === 38 && autocompleteSelectedIndex > 0)
                autocompleteSelectedIndex = autocompleteSelectedIndex - 2;

            autoComplete.find('li').eq(autocompleteSelectedIndex).addClass('active');

            // Refresh scroll view.
            const activeItem = autoComplete.find('li.active');

            if (autoComplete.outerHeight() >= 200) {
                const scrollBy = activeItem[0].offsetTop - autoComplete.innerHeight() + activeItem[0].scrollHeight;

                autoComplete.animate({
                    scrollTop: scrollBy
                }, 200);
            }
            //--

            autocompleteSelectedIndex++;

            if (autocompleteSelectedIndex < 1)
                autocompleteSelectedIndex = 0;
        }

        // If enter is pressed then select the active item.
        if (e.keyCode === 13 && autoComplete.hasClass('active')) {
            autoComplete.find('li.active').trigger('click');
            autocompleteSelectedIndex = 0;
        }

        // If down arrow pressed and no search term entered then return all results.
        if (e.keyCode === 40 && textInput.val().length < 1 && !autoComplete.hasClass('active')) {

            openAutocomplete(containerId);
            toggleSearchArrow(containerId);

            outputSearchTerm(null);
            autocompleteSelectedIndex = 0;
        }

        // If the key pressed is not up arrow, down arrow or enter then return the search term.
        if (e.keyCode !== 40 && e.keyCode !== 38 && e.keyCode !== 13) {

            openAutocomplete(containerId);
            toggleSearchArrow(containerId);

            autocompleteSelectedIndex = 0;

            clearTimeout(timeout);

            timeout = setTimeout(function () {

                if (textInput.val().length > 1) {
                    outputSearchTerm(textInput.val());
                }
                else {
                    closeAndResetAutocomplete(containerId);
                    toggleSearchArrow(containerId);
                    autocompleteSelectedIndex = 0;
                }

            }, 500);
        }

    });


    textInput.off('dblclick').on('dblclick', function () {

        var e = $.Event('keyup');
        e.keyCode = 40; // Character 'down arrow'
        textInput.trigger(e);
    });


    bindSearchDropdown(containerId, function (onComplete) {
        outputSearchTerm(null);
    });

}

export function openAutocomplete(containerId) {
    const searchTextbox = $(containerId + ' .search-textbox');
    const autoComplete = $(containerId + ' .search-autocomplete');

    //the following code checks the available screen height between the bottom of the autocomplete textbox and the bottom of the visible screen.
    //if the height available is LESS than height of the autocomplete results container (supplied as a fixed height) the result container is 
    //displayed above the textbox.

    //check available height from bottom of element to bottom of visible page
    const elementTop = searchTextbox.offset().top; //get the offset top of the element
    const offsetTop = elementTop - $(window).scrollTop();
    const offsetBottom = ($(window).height() - offsetTop) - searchTextbox.outerHeight();

    if (offsetBottom < 255) {
        //the value to be less than should be slightly greater than the height of the ac menu in pixels
        //not enough space to display underneath. apply class to display above instead
        autoComplete.addClass('display-above');
        autoComplete.css({ "bottom": + searchTextbox.outerHeight() + "px" });
    }
    else {
        autoComplete.removeClass('display-above');
        autoComplete.css({ "bottom": "inherit" });
    }

    autoComplete.addClass('active');
    searchTextbox.focus();

    $(searchTextbox).one('click', function (e) {
        e.stopPropagation();
    });

    $('html').one('click', function () {
        clearSearch(containerId);
    });
}

export function closeAndResetAutocomplete(containerId) {
    const autoComplete = $(containerId + ' .search-autocomplete');
    autoComplete.removeClass('active');
    autoComplete.empty();
    autoComplete.html('<li><div class="submit-activity default-ripple vertical-align-webkit-middle margin-centre"><div></div><div></div></div></li>');
}

export function clearSearchTextbox(containerId) {
    $(containerId + ' .search-textbox').val("");
}

export function bindSearchDropdown(containerId, onComplete) {
    const dropdownBtn = $(containerId + ' .icon-arrow-down-wrapper');
    const autoComplete = $(containerId + ' .search-autocomplete');

    dropdownBtn.click(function (e) {
        e.preventDefault();
        e.stopPropagation();

        if (autoComplete.hasClass('active')) {
            clearSearch(containerId);
            onComplete(false);
        }
        else {
            clearSearchTextbox(containerId);
            closeAndResetAutocomplete(containerId);
            openAutocomplete(containerId);

            toggleSearchArrow(containerId);
            onComplete(true);
        }

    });
}

export function toggleSearchArrow(containerId) {
    const dropdownBtn = $(containerId + ' .icon-arrow-down');
    const autoComplete = $(containerId + ' .search-autocomplete');

    if (autoComplete.hasClass('active'))
        dropdownBtn.addClass('point-up');
    else
        dropdownBtn.removeClass('point-up');
}

export function clearSearch(containerId) {
    closeAndResetAutocomplete(containerId);
    clearSearchTextbox(containerId);
    toggleSearchArrow(containerId);
}

export const noResultHtml = '<li class="padding-10 text-center">No Results</li>';